module.exports = __webpack_public_path__ + "img/logo.f59f2965.png";